import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * Shared i18n bootstrap. Languages ru / kk per the accepted decision — do not
 * introduce kz naming. Each app passes its own resource bundles.
 */
export type SupportedLanguage = 'ru' | 'kk';

export const supportedLanguages: Array<SupportedLanguage> = ['ru', 'kk'];

export function initI18n(
  resources: Record<SupportedLanguage, Record<string, Record<string, unknown>>>,
  lng: SupportedLanguage = 'ru',
) {
  const firstLng = Object.keys(resources)[0] as SupportedLanguage;
  const ns = Object.keys(resources[firstLng]);
  const defaultNS = ns[0];

  void i18n.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng: 'ru',
    ns,
    defaultNS,
    interpolation: { escapeValue: false },
  });
  return i18n;
}
